export enum ImageTags {
  ModalProgramImage = 'modalProgramImage',
}
